import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getPostLoginPath } from '../../utils/postLoginPath';

interface GuestRouteProps {
  children: React.ReactNode;
}

/**
 * Inverse of ProtectedRoute: keeps already-authenticated visitors off the
 * public landing and login pages.
 *
 * The `isLoading` gate matters — the session is restored from localStorage
 * asynchronously, so rendering the children first would flash the marketing
 * page at signed-in users on every visit to the site root.
 */
export const GuestRoute: React.FC<GuestRouteProps> = ({ children }) => {
  const { isAuthenticated, user, buyer, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto mb-2"></div>
          <p className="text-sm text-gray-500">Loading...</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={getPostLoginPath(user, buyer)} replace />;
  }

  return <>{children}</>;
};
